import { useEffect } from 'react'
import { SESSION_STORAGE } from '../constants/sessionStorage'
import { WARNING_BAR } from '../constants/warningBar'
import { t } from '../i18n'
import { useReportStore } from '../Stores/reportStore'
import { useRunPetisSimulationStore } from '../Stores/useRunPetisSimulationStore'
import { useWarningStore } from '../Stores/warningStore'

export const useChangedSimulationNumber = () => {
  const { setWarningOptions } = useWarningStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()
  const { setIsReportGeneratedEnabled } = useReportStore()

  useEffect(() => {
    const oldRpsQuoteId = sessionStorage.getItem(SESSION_STORAGE.oldRpsQuoteId)
    const simulationNumber =
      runPetisSimulation?.runPetisSimulationResponse?.quoteId

    if (
      (simulationNumber || '')?.length > 0 &&
      (oldRpsQuoteId || '')?.length > 0 &&
      oldRpsQuoteId !== simulationNumber
    ) {
      setWarningOptions({
        type: WARNING_BAR.type.info,
        labelTypes: [
          t('general.infoChangedSimulationNumber', {
            newSimulationNumber: simulationNumber,
          }),
        ],
      })

      setIsReportGeneratedEnabled(true)

      sessionStorage.setItem(
        SESSION_STORAGE.oldRpsQuoteId,
        simulationNumber || '',
      )
    }
  }, [runPetisSimulation])
}
